// @ts-nocheck
/**
 * @module Fullstory
 * @description
 */
import { useContext, useEffect, useState } from 'react';
import { CustomCohesionContext } from 'ui/providers/cohesion';
import Script from 'next/script';
import { getAsset } from 'ui/js/utils/helpers';
import requestMonarch from 'ui/js/helpers/monarch';

export const Fullstory = () => {
  const { cohesionReady } = useContext( CustomCohesionContext );

  const [ determineFullstory, setDetermineFullstory ] = useState( false );

  useEffect( () => {
    if ( ! cohesionReady ) return;

    requestMonarch( 'rule', 'determineFullstory', {}, {}, ( result ) => {
      if ( result?.determineFullstory === true ) {
        setDetermineFullstory( true );
      }
    } );
  }, [ cohesionReady ] );

  if ( ! determineFullstory ) {
    return null;
  }

  return (
    <Script
      src={ `${ getAsset( '/rv-assets/js/fullstory.js' ) }` }
      strategy="afterInteractive"
      onLoad={ () => {
        if ( typeof ( window._Cohesion ) !== 'undefined' ) {
          // Sends the Cohesion session ID over to FullStory for better tracking
          window.FS.identify( window._Cohesion.sessionId );
          window.FS.setUserVars( {
            cohesionSessionId_str: window._Cohesion.sessionId,
            domain_str: window.location.hostname,
            userAgent_str: window.navigator.userAgent
          } );
        }
      } }
    />
  );
};

Fullstory.displayName = 'Fullstory';

export default Fullstory;
